var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInstagramLine(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M18.965 5.131a.9.9 0 0 1-1.8 0m1.8 0a.9.9 0 0 0-1.8 0m1.8 0h-1.8M17.073 1H6.927A5.927 5.927 0 0 0 1 6.927v10.146A5.927 5.927 0 0 0 6.928 23h10.144A5.928 5.928 0 0 0 23 17.072V6.927A5.927 5.927 0 0 0 17.073 1Zm.238 11A5.31 5.31 0 1 1 6.69 12a5.31 5.31 0 0 1 10.62 0Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstagramLine);
export default __webpack_public_path__ + "static/media/instagram_line.2fadf5a2d7b889dde7091fc5cbc769b6.svg";
export { ForwardRef as ReactComponent };